import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface TUnassignedFeeData {
  menuItemId: number
  menuItemName: string
  menuItemSku: string | null
  isEvent: number
  maxQuantityPerStudent: number | null
  maxQuantity: number | null
  description: string
  price: number
  fullPrice: number
  formData: string | null
  formSubmissionId: string | null
  familyMaxId: number | null
  onHoldAllowedToPurchase: number
  variablePricingEnabled: number
  partialPaymentEnabled: number
  programYearId: number
  orderItemTypeId: number
  // DTA-949: set when the item is a community coupon book.
  couponBookId?: number
  couponBookBeneficiary?: string
  couponBookExpires?: string
  /** DTA-1092: the app the fee belongs to (1012 Childcare, 1014 Athletics), or null */
  moduleId?: number | null
}

// GET /ajax/student/{student_account_id}/other_fee/unassigned
export const unassignedFees = async (studentAccountId: number) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/other_fee/unassigned'
  )
  return Util.Obj.keysToCamel(response.data.items) as TUnassignedFeeData[]
}
